/** @format */

import React from "react";
import { Layout } from "antd";
import { toggleCollapsedSideNav } from "../../appRedux/actions/Setting";
import Auxiliary from "util/Auxiliary";
import UserProfile from "../Sidebar/UserProfile";
import {
  NAV_STYLE_FIXED,
  NAV_STYLE_DRAWER,
  NAV_STYLE_MINI_SIDEBAR,
  TAB_SIZE,
} from "../../constants/ThemeSetting";
import { useDispatch, useSelector } from "react-redux";

const { Header } = Layout;

const PAGE_TITLE_MAP = [
  ["p2p-statistics",          "P2P Statistics"],
  ["P2PMerchant",             "P2P Merchants"],
  ["P2PTransactions",         "P2P Transactions"],
  ["P2PSettings",             "P2P Settings"],
  ["support-chat",            "Support Chat"],
  ["dashboard",               "Dashboard"],
  ["sub-admin",               "Manage Sub Admins"],
  ["translations",            "Translation"],
  ["iam",                     "IAM"],
  ["card-deposits",           "Card Deposits"],
  ["withdrawal",              "Fiat Withdrawals"],
  ["deposit",                 "Fiat Deposits"],
  ["crypto/orders",           "Trades"],
  ["crypto",                  "Crypto Transactions"],
  ["ledger",                  "Profit Ledger"],
  ["trades",                  "User Trades"],
  ["reimbursements",          "Reimbursements"],
  ["activities",              "Admin Activities"],
  ["country-feature-control", "Country Whitelist"],
  ["otp",                     "OTP Settings"],
  ["providers",               "Providers"],
  ["protocols",               "Protocols"],
  ["email-templates",         "Email Templates"],
  ["requests",                "Admin Requests"],
  ["liquidity-monitoring",    "Liquidity Monitoring"],
  ["unauthorized",            "Unauthorized"],
];

const Topbar = () => {
  const { navStyle }              = useSelector(({ settings }) => settings);
  const { navCollapsed, width }   = useSelector(({ common })   => common);
  const { pathname }              = useSelector(({ common })   => common);
  const dispatch = useDispatch();

  const currentPath = pathname.substr(1);
  const pageLabel   = PAGE_TITLE_MAP.find(([key]) => currentPath.includes(key))?.[1] ?? "";

  return (
    <Header>
      {/* ── Hamburger (mobile / mini-sidebar) ── */}
      {navStyle === NAV_STYLE_DRAWER ||
      ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) &&
        width < TAB_SIZE) ? (
        <div className="gx-linebar gx-mr-3">
          <i
            className="gx-icon-btn icon icon-menu"
            onClick={() => dispatch(toggleCollapsedSideNav(!navCollapsed))}
          />
        </div>
      ) : null}

      {/* ── Page title ── */}
      {pageLabel ? (
        <h2 className="title gx-mb-0">{pageLabel}</h2>
      ) : null}

      {/* ── Right-side: avatar (mobile only — desktop uses sidebar UserProfile) ── */}
      <ul className="gx-header-notifications gx-ml-auto">
        {width >= TAB_SIZE ? null : (
          <Auxiliary>
            <li className="gx-user-nav">
              <UserProfile topbar />
            </li>
          </Auxiliary>
        )}
      </ul>
    </Header>
  );
};

export default Topbar;
